import { type IacTableGroupMeta } from "./types";

export const DEFAULT_GROUP_META: IacTableGroupMeta = { isOpen: false, hasMore: false };
